import { useState } from "react";
import styles from "./subMenuSpecial.module.scss";
import SubMenuSpecialItem from "./SubMenuSpecialItem";
import type { IMenu } from "../../../../../../constants";

interface SubMenuSpecialProps {
  items: IMenu[];
  onBlurItem: () => void;
}

const SubMenuSpecial = (props: SubMenuSpecialProps) => {
  const { items, onBlurItem } = props;
  const [levelItem, setLevelItem] = useState<IMenu>();
  const [gradeItem, setGradeItem] = useState<IMenu>();
  const [activeItems, setActiveItems] = useState<number[]>([]);

  return (
    <div
      id="SubMenuSpecial"
      className={`${styles["sub-menu"]}`}
      onMouseLeave={() => {
        setLevelItem(undefined);
        setGradeItem(undefined);
        setActiveItems([]);
      }}
    >
      <ul className={styles["sub-menu__column"]}>
        {items?.map((item) => (
          <SubMenuSpecialItem
            item={item}
            key={item.linkID}
            activeItems={activeItems}
            type={"level-1"}
            onBlurItem={onBlurItem}
            onHover={() => {
              setActiveItems([item.linkID]);
              setLevelItem(item);
              setGradeItem(undefined);
            }}
          />
        ))}
      </ul>
      {levelItem?.childs && (
        <ul className={styles["sub-menu__column"]} id="SubMenuSpecial-childs">
          {levelItem?.childs?.linkList.map((item) => (
            <SubMenuSpecialItem
              item={item}
              key={item.linkID}
              type={"level-2"}
              activeItems={activeItems}
              onBlurItem={onBlurItem}
              onHover={() => {
                const newItems = [...activeItems];
                newItems[1] = item.linkID;
                setActiveItems(newItems);
                setGradeItem(item);
              }}
            />
          ))}
        </ul>
      )}
      {gradeItem && gradeItem.childs && (
        <ul className={styles["sub-menu__column"]}>
          {gradeItem?.childs?.linkList.map((item) => (
            <SubMenuSpecialItem
              item={item}
              type={"level-3"}
              key={item.linkID}
              onBlurItem={onBlurItem}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default SubMenuSpecial;
